import React, { useEffect, useRef, useState } from 'react';
import { Card, Row, Col, Result, Button, Spin } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../services/authService';

type State =
  | { kind: 'loading' }
  | { kind: 'success'; claimedOrders: number; message: string }
  | { kind: 'error'; message: string };

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState<State>({ kind: 'loading' });
  const ran = useRef(false);

  useEffect(() => {
    // Guard against React StrictMode double-invoke (token is single-use).
    if (ran.current) return;
    ran.current = true;

    const token = searchParams.get('token');
    if (!token) {
      setState({ kind: 'error', message: 'This verification link is missing its token.' });
      return;
    }
    authService
      .verifyEmail(token)
      .then((r) => setState({ kind: 'success', claimedOrders: r.claimedOrders, message: r.message }))
      .catch((err) =>
        setState({ kind: 'error', message: err instanceof Error ? err.message : 'Verification failed' })
      );
  }, [searchParams]);

  return (
    <div style={{ minHeight: '100vh', background: '#f0f2f5', padding: '40px 0' }}>
      <Row justify="center" align="middle" style={{ minHeight: '60vh' }}>
        <Col xs={22} sm={18} md={14} lg={10} xl={8}>
          <Card>
            {state.kind === 'loading' && (
              <div style={{ textAlign: 'center', padding: '40px 0' }}>
                <Spin size="large" />
                <div style={{ marginTop: 16, color: '#666' }}>Verifying your email…</div>
              </div>
            )}

            {state.kind === 'success' && (
              <Result
                status="success"
                title="Email verified!"
                subTitle={
                  state.claimedOrders > 0
                    ? `Your email is verified and ${state.claimedOrders} past order(s) have been added to your account.`
                    : 'Your email address has been verified.'
                }
                extra={[
                  <Button type="primary" key="orders" onClick={() => navigate('/profile?tab=orders')}>
                    View My Orders
                  </Button>,
                  <Button key="shop" onClick={() => navigate('/products')}>
                    Continue Shopping
                  </Button>,
                ]}
              />
            )}

            {state.kind === 'error' && (
              <Result
                status="warning"
                title="Verification failed"
                subTitle={state.message}
                extra={[
                  <Button type="primary" key="login" onClick={() => navigate('/login')}>
                    Go to Sign In
                  </Button>,
                ]}
              />
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default VerifyEmail;
